export default __webpack_public_path__ + "img/ZBsgfVMl.532b5a86.svg";